import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { navigationOperations } from '../store';

export const useNavigationOperations = (): typeof navigationOperations => {
  const bindedActions = useBindActionCreators(navigationOperations);
  return bindedActions;
};
